module.exports = __webpack_public_path__ + "static/media/geannuleerd_white.ac2bb3d4.svg";